<template>
    <div class="footer-copyright">
        <div class="container">
            <div class="footer-terms">
                <a href="##">Terms of Use</a><a href="##" class="fotr-Privacy" title="">Privacy Policy</a>
            </div>
            <span>Copyright 2010-{{ currentYear }} | DC Trainings, Inc. All Right Reserved</span>
            <div class="footer-social">
                <a href="##"><img src="./../../assets/images/fotr-social.png" alt=""></a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentYear: new Date().getFullYear()
        };
    }
};
</script>
